const authInitialState = {
    userDeatils: null,
    accessToken: null,
    role: null,
    is_admin: null,
    is_staff: null,
    name:"",
    default_zoom_link:"",
    total_coin : ""
};
export default authInitialState;
